import types from './types'

export const loadCustomerApprovals = (token) => ({ type: types.CUSTOMER_APPROVALS_LOAD_ATTEMPT, token })
export const loadCustomerApprovalsSuccess = (data) => ({ type: types.CUSTOMER_APPROVALS_LOAD_SUCCESS, data })
export const loadCustomerApprovalsFailure = (message, code) => ({ type: types.CUSTOMER_APPROVALS_LOAD_FAILURE, message, code })

export const updateCustomerApprovalStatus = (token, id, status, changeText, name, isRevertingStatus) => ({ type: types.CUSTOMER_APPROVAL_UPDATE_STATUS_ATTEMPT, token, id, status, changeText, name, isRevertingStatus })
export const updateCustomerApprovalStatusSuccess = (data) => ({ type: types.CUSTOMER_APPROVAL_UPDATE_STATUS_SUCCESS, data })
export const updateCustomerApprovalStatusFailure = (message, code) => ({ type: types.CUSTOMER_APPROVAL_UPDATE_STATUS_FAILURE, message, code })
